<p-toast key="newRequestErrors">
    <ng-template let-message pTemplate="message">
        <div>
            <h4> {{ message.summary | translate }} </h4>
            <p> {{ message.detail | translate }} </p>
            <ul *ngIf="message.data">
                <li *ngFor="let data of message.data">
                    <span class="material-symbols-outlined"> warning </span>
                    {{data | translate}}
                </li>
            </ul>
        </div>
    </ng-template>
</p-toast>

<p-toast key="docPackError" />

<p-confirmDialog />


@switch (newRequestStatus.step) {
    @case (1){
        <app-loading [isLoading]="isLoading" [messages]="waitingMessages">
            <h3 class="form-title">{{ "NEW_REQUEST.REQUEST_DATA" | translate }}</h3>
            <app-inside-disable [isDisabled]="formIsDisabled">
                <form [formGroup]="newStandardRequestService.myForm" disabled>
                    <div class="grid">

                        <div class="col-4">
                            <label for="_laborSituation">{{ 'NEW_REQUEST.REQUEST_TYPE' | translate }}</label>
                            <p-select
                                id="_laborSituation"
                                [options]="laborSituations"
                                [optionValue]="'id'"
                                [optionLabel]="'label'"
                                (onChange)="onLaborSituationChange($event)"
                            >
                                <ng-template let-item pTemplate="selectedItem">
                                    <div>
                                        {{ item.label | translate }}
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div>
                                        {{ option.label | translate }}
                                    </div>
                                </ng-template>
                            </p-select>
                        </div>

                        <div class="col-4">
                            <label for="_requiredService">{{ 'NEW_REQUEST.ACCESS_TYPE' | translate }}</label>
                            <p-select
                                id="_requiredService"
                                [options]="availableServices"
                                [(ngModel)]="selectedRequestType"
                                [ngModelOptions]="{ standalone: true }"
                                [optionValue]="'id'"
                                [optionLabel]="'label'"
                                (onChange)="onRequiredServiceChange($event)"
                            >
                                <ng-template let-item pTemplate="selectedItem">
                                    <div>
                                        {{ item.label | translate }}
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div>
                                        {{ option.label | translate }}
                                    </div>
                                </ng-template>
                            </p-select>
                        </div>

                        <div class="col-4" *ngIf="newStandardRequestService.myForm.get('documentationPack')">
                            <label for="_documentationPack">{{ 'NEW_REQUEST.DOC_PACK' | translate }}</label>
                            <p-select
                                #docPackDropdown
                                id="_documentationPack"
                                [options]="availableDocPacks"
                                [optionValue]="'id'"
                                [optionLabel]="'localizedLabel'"
                                placeholder="{{ 'FILTER.SELECT' | translate }}"
                                formControlName="documentationPack"
                            >
                                <ng-template let-item pTemplate="selectedItem">
                                    <div>
                                        {{ item.localizedLabel }}
                                    </div>
                                </ng-template>

                                <ng-template let-option pTemplate="item">
                                    <div>
                                        {{ option.localizedLabel }}
                                    </div>
                                </ng-template>
                            </p-select>
                        </div>

                        <!-- *** BELENDER WIDGET LANG *** -->
                        <div class="col-4" *ngIf="showWidgetLanguageSelector">
                            <label for="language">{{ 'NEW_REQUEST.BELENDER_WIDGET_LANG' | translate }}</label>
                            <p-select
                                id="language"
                                [options]="belenderWidgetLangOptions"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="language"
                            >
                                <ng-template let-option pTemplate="selectedItem">
                                    <div>{{ option.label | translate }}</div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div>{{ option.label | translate }}</div>
                                </ng-template>
                            </p-select>
                        </div>

                        <!-- ========== PERSONA FÍSICA (Physical_Person) ========== -->
                        @if (selectedRequestorType === 'Physical_Person') {
                            <div class="break-row"></div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('firstName')">
                                <label for="_name">{{ "NEW_REQUEST.NAME" | translate }}</label>
                                <input pInputText="_name" id="_name" formControlName="firstName" maxLength="20" />
                            </div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('firstSurname')">
                                <label for="_first-surame">{{ "NEW_REQUEST.FIRST_SURNAME" | translate }}</label>
                                <input pInputText="surame" id="surame" formControlName="firstSurname" maxLength="20" />
                            </div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('secondSurname')">
                                <label for="_second-surname">{{ "NEW_REQUEST.SECOND_SURNAME" | translate }}</label>
                                <input pInputText="_second-surname" id="_second-surname" formControlName="secondSurname" maxLength="20" />
                            </div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('personId')">
                                <label for="_documentNumber">{{ 'NEW_REQUEST.ID_NUMBER_STANDARD' | translate }}</label>
                                <input pInputText id="_documentNumber" formControlName="personId" maxLength="9" />
                            </div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('personIdExpirationDate') && selectedRequestType === 'Clave_Pin'">
                                <label for="_expirationDate">{{ 'NEW_REQUEST.ID_EXPIRATION_DATE' | translate }}</label>
                                <p-datepicker id="_expirationDate" formControlName="personIdExpirationDate" dateFormat="dd/mm/yy"
                                [showIcon]="true" />
                            </div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('birthDate')">
                                <label for="date">{{ 'NEW_REQUEST.BIRTH_DATE' | translate }}</label>
                                <p-datepicker id="date" formControlName="birthDate" dateFormat="dd/mm/yy" [showIcon]="true" />
                            </div>

                            <div class="col-4" *ngIf="newStandardRequestService.myForm.get('supportNumber')">
                                <label for="_supportNumber">{{ 'NEW_REQUEST.SUPPORT_NUMBER_NIE' | translate }}</label>
                                <input pInputText id="_supportNumber" formControlName="supportNumber" maxLength="9" />
                            </div>

                            <div class="col-5" *ngIf="newStandardRequestService.myForm.get('email')">
                                <label for="_email">{{ 'NEW_REQUEST.EMAIL_OPTIONAL' | translate }}</label>
                                <input pInputText="_email" formControlName="email" />
                            </div>

                            <div class="col-3" *ngIf="newStandardRequestService.myForm.get('phoneNumber')">
                                <label for="_phone">{{ 'NEW_REQUEST.PHONE' | translate }}</label>
                                <input pInputText="_phone" formControlName="phoneNumber" maxLength="9" />
                            </div>
                        }

                        <!-- ========== PERSONA JURÍDICA (Legal_Person) ========== -->
                        @if (selectedRequestorType === 'Legal_Person') {
                            <!-- Sección: Empresa -->
                            <div class="col-12">
                                <h4 class="section-title m-0">{{ 'NEW_REQUEST.COMPANY_SECTION' | translate }}</h4>
                            </div>

                            <div class="col-4">
                                <label for="_companyName">{{ 'NEW_REQUEST.COMPANY_NAME' | translate }}</label>
                                <input pInputText id="_companyName" formControlName="companyName" maxLength="100" />
                            </div>

                            <div class="col-4">
                                <label for="_companyId">{{ 'NEW_REQUEST.TIN' | translate }}</label>
                                <input pInputText id="_companyId" formControlName="companyId" maxLength="9" />
                            </div>

                            <div class="break-row"></div>

                            <!-- Sección: Representante Legal -->
                            <div class="col-12">
                                <h4 class="section-title m-0">{{ 'NEW_REQUEST.LEGAL_REPRESENTATIVE_SECTION' | translate }}</h4>
                            </div>

                            <div class="col-4">
                                <label for="_legalRepName">{{ 'NEW_REQUEST.NAME' | translate }}</label>
                                <input pInputText id="_legalRepName" formControlName="firstName" maxLength="20" />
                            </div>

                            <div class="col-4">
                                <label for="_legalRepFirstSurname">{{ 'NEW_REQUEST.FIRST_SURNAME' | translate }}</label>
                                <input pInputText id="_legalRepFirstSurname" formControlName="firstSurname" maxLength="20" />
                            </div>

                            <div class="col-4">
                                <label for="_legalRepSecondSurname">{{ 'NEW_REQUEST.SECOND_SURNAME' | translate }}</label>
                                <input pInputText id="_legalRepSecondSurname" formControlName="secondSurname" maxLength="20" />
                            </div>

                            <div class="break-row"></div>

                            <div class="col-4">
                                <label for="_legalRepEmail">{{ 'NEW_REQUEST.EMAIL' | translate }}</label>
                                <input pInputText id="_legalRepEmail" formControlName="email" />
                            </div>

                            <div class="col-3">
                                <label for="_legalRepPhone">{{ 'NEW_REQUEST.PHONE' | translate }}</label>
                                <input pInputText id="_legalRepPhone" formControlName="phoneNumber" maxLength="9" />
                            </div>
                        }
                    </div>

                    <app-admin-messages #adminMessages [type]="adminMessagesType" (isOk)="isAdminOk = $event" />

                    <div class="buttons-row">
                        <span class="access-type-help" *ngIf="accessTypeHelpText">{{ accessTypeHelpText }}</span>
                        @if (isAdminOk) {
                            <button class="filled-btn" (click)="onSubmit()">{{ 'NEW_REQUEST.CREATE_REQUEST' | translate }}</button>
                        } @else {
                            <button class="filled-btn" (click)="adminMessages.setMessages()">{{ 'NEW_REQUEST.CHECK_STATUS' | translate }}</button>
                        }
                    </div>

                </form>
            </app-inside-disable>
        </app-loading>
    }
    @case (2){
        <app-loading [isLoading]="isLoadingRequest">
            <h3 class="form-title">{{ "NEW_REQUEST.REQUEST_SUMMARY" | translate }}</h3>
            <div class="grid form-inline label-W170" *ngIf="newStandardRequestService.myForm.get('firstName')">
                <div class="col-12 mb-1">
                    <label for="_name" class="label-min-width">{{ "NEW_REQUEST.NAME" | translate }}</label>
                    <div class="read-only">
                        <span id="_name">{{ newStandardRequestService.myForm.get("firstName").value }}</span>
                    </div>
                </div>

                <div class="col-12 mb-1" *ngIf="newStandardRequestService.myForm.get('firstSurname')">
                    <label for="_first-surame" class="label-min-width">{{ "NEW_REQUEST.FIRST_SURNAME" | translate }}</label>
                    <div class="read-only">
                        <span id="_first-surname">{{ newStandardRequestService.myForm.get("firstSurname").value }}</span>
                    </div>
                </div>

                <div class="col-12 mb-1" *ngIf="newStandardRequestService.myForm.get('secondSurname')">
                    <label for="_second-surname" class="label-min-width">{{ "NEW_REQUEST.SECOND_SURNAME" | translate }}</label>
                    <div class="read-only">
                        <span id="_second-surname">{{ newStandardRequestService.myForm.get("secondSurname").value }}</span>
                    </div>
                </div>

                <div class="col-12 mb-1" *ngIf="newStandardRequestService.myForm.get('personId')">
                    <label for="_document-number" class="label-min-width">{{ "NEW_REQUEST.ID_NUMBER" | translate }}</label>
                    <div class="read-only">
                        <span id="_document-number">{{ newStandardRequestService.myForm.get("personId").value }}</span>
                    </div>
                </div>

                <div class="col-12 mb-1" *ngIf="newStandardRequestService.myForm.get('personType')">
                    <label for="_labor-situation" class="label-min-width">{{ 'NEW_REQUEST.REQUEST_TYPE' | translate }}</label>
                    <div class="read-only">
                        <span id="_labor-situation">{{ 'PERSON_TYPES.' + newStandardRequestService.myForm.get("personType").value | translate }}</span>
                    </div>
                </div>

                <div class="col-12 mb-1" *ngIf="newStandardRequestService.myForm.get('phoneNumber')">
                    <label for="_phone" class="label-min-width">{{ "NEW_REQUEST.PHONE" | translate }}</label>
                    <div class="read-only">
                        <span id="_phone">{{ newStandardRequestService.myForm.get("phoneNumber").value }}</span>
                    </div>
                </div>

                <div class="col-12 mb-1" *ngIf="showEmailField()">
                    <label for="_email" class="label-min-width">{{ "NEW_REQUEST.EMAIL_OPTIONAL" | translate }}</label>
                    <div class="read-only">
                        <span id="_email">{{ newStandardRequestService.myForm.get("email").value }}</span>
                    </div>
                </div>
            </div>

            @if (physicalPersonQueryResponse.consentUrlBoxed) {
                <div class="center">
                    <app-qr-code [value]="physicalPersonQueryResponse.consentUrlBoxed" [showLabel]="true" />
                </div>
            }

            <div class="info-box">
                <span class="material-symbols-outlined"> check_circle </span>
                <p>
                    @if (currentBelenderCircuit === 6) {
                        {{ "NEW_REQUEST.EMAIL_SENT_TO_APPLICANT" | translate }}
                    } @else {
                        {{ "NEW_REQUEST.SMS_SENT_TO_APPLICANT" | translate }}
                    }
                </p>
            </div>

            <div class="buttons-row">
                <button class="outline-btn" (click)="continueOTP()">{{ "REQUEST_DETAIL.CONTINUE_OTP" | translate }}</button>
                <button class="filled-btn" (click)="goToDetail()">{{ "NEW_REQUEST.DETAILS" | translate }}</button>
            </div>
        </app-loading>
    }
    @case (3){
        <app-belender-widget class="widget" [url]="trustedConsentUrl" />

        <!-- <div class="buttons-row" *ngIf="detailButtonIsVisible()">
            <button class="filled-btn" (click)="goToDetail()" [disabled]="!physicalPersonQueryResponse && !newStandardRequestService.isFinishingOTP">
                {{ "NEW_REQUEST.DETAILS" | translate }}
            </button>
        </div> -->
    }
}
